// components/ProfileDropdown.js
import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from "react-router-dom";
import { useTheme } from '../../../../hooks/ThemeProvider';
import { defaultUserProfile } from '../../../../utils/constant';
import { formatAddress } from '../../../../helper';
import useWallet from '../../../../hooks/useWallet';
const ProfileDropdown = ({

    userProfile,
    onEditProfile,
    onDisconnectWallet
}) => {
    const { theme } = useTheme();

    const { address } = useWallet();

    return (
        <div className="profile_button">
            <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <img src={userProfile.imageUrl || defaultUserProfile?.imageUrl} className="useer_img" />
                    <span className="alex_text">{userProfile.name || defaultUserProfile?.name}</span>
                    {
                        theme === 'dark' ? <svg className="svggggsign" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
                            <path d="M1 1.5L4 4.5L7 1.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M3 4.5L6 7.5L9 4.5" stroke="#000F2F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    }

                </Dropdown.Toggle>
                <Dropdown.Menu align="end" >
                    <div className="innner_side">
                        <Dropdown.Item className="inner_Drop newdropppp" as="div">
                            <Link to='/profile' className="inner_more">
                                <img src={userProfile.imageUrl} className="profillle" />
                                <div>
                                    <h5>{userProfile.name || defaultUserProfile?.name}</h5>
                                    <span className="addressssno">{formatAddress(address)}</span>
                                    {userProfile?.description && (
                                        <h6 className="root_text">{userProfile?.description?.slice(0, 18)}...</h6>
                                    )}
                                </div>
                            </Link>
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/profile" className="inner_Drop">
                            <div className="inner_more">
                                <img src="/assets/profile.svg" alt="Profile" className="profillle" />
                                <h5>My Profile</h5>
                            </div>
                        </Dropdown.Item>


                        <Dropdown.Item className="inner_Drop" as="div">
                            <div className="inner_more" onClick={onEditProfile}>
                                <img src="\assets\edit.svg" className="profillle" />
                                <h5>Edit Profile</h5>
                            </div>
                        </Dropdown.Item>
                        <Dropdown.Item className="inner_Drop" as="div">
                            <div className="inner_more" onClick={onDisconnectWallet}>
                                <img src="\assets\disconnect.svg" className="profillle" />
                                <h5>Disconnect Wallet</h5>
                            </div>
                        </Dropdown.Item>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default ProfileDropdown;